
import { ActionsRepository } from "../../infra/repository/actions.repository";
import { Action } from "../domain/actions";

export class CreateActionUseCase {
    static async execute(action: Action): Promise<Action | undefined> {
        try {
            const response = await ActionsRepository.create(action);
            if (response.error) {
                throw Error("Erro ao criar ação");
            }
            return response.data;
        } catch (error) {        
            throw Error("Erro ao criar ação");
        }
    }
}